import Vue from 'vue'
import VueI18n from 'vue-i18n'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import Multiselect from 'vue-multiselect'
import App from './App.vue';
import messages from './langs'
import store from './store'
import './bootstrap';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

Vue.use(PerfectScrollbar)
Vue.use(VueI18n)
Vue.component('multiselect', Multiselect)
const i18n = new VueI18n({
  locale,
  messages
})

new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#ticket_module')
